import ThirdPartyFuneralWizard from './ThirdPartyFuneralWizard'

export default ThirdPartyFuneralWizard
